import React from "react";
import { Routes } from "./routes/Routes";
import { UIProvider } from "./context/ui/UIContext";
import { BrowserRouter } from "react-router-dom";
import { ParamsProvider } from "./context/paramsConfig/ParamsConfigContext";
import { ThemeProvider } from "context/theme/ThemeContext";
import "./styles/globals.scss";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? ""}>
      <ThemeProvider>
        <UIProvider>
            <BrowserRouter>
              <ParamsProvider>
                <Routes />
              </ParamsProvider>
            </BrowserRouter>
        </UIProvider>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
